/*
 * Created by Ali Simsek on 6/3/20, 6:58 PM
 * Copyright (c) 2020 Carla Car Rental, Inc. All rights reserved.
 * Last modified 6/3/20, 6:58 PM
 */

import styled from 'styled-components'
import { CardFlexEl, FlexEl } from '../layout'
import { CheckboxDown, CheckboxUp, SearchIcon } from '../svg'
import { SearchPreferenceForm } from '../SearchForm/DesktopForm'
import React from 'react'
import { bool, func } from 'prop-types'

export const SearchBoxForm = styled(({ onToggleSearch, searchExpanded, onSearchClicked, ...props }) => (
  <CardFlexEl {...props} show={[0, 1, 1]} width={[1, 1, 320]}>
    <FlexEl
      css={`
        width: 100%;
        justify-content: space-between;
        padding: 30px 16px;
      `}
    >
      <FlexEl
        css={`
          justify-content: center;
          align-items: center;
        `}
      >
        <SearchIcon />
        <FlexEl
          css={`
            color: white;
            font-weight: 500;
            margin-left: 4px;
          `}
        >
          Change Search Preference
        </FlexEl>
      </FlexEl>
      <FlexEl onClick={onToggleSearch}>{searchExpanded ? <CheckboxUp /> : <CheckboxDown />}</FlexEl>
    </FlexEl>
    {searchExpanded && <SearchPreferenceForm onSubmit={onSearchClicked} />}
  </CardFlexEl>
))`
  min-width: 320px;
  max-width: 784px;
  height: fit-content;
  margin-bottom: 16px;
  background-color: #273c75;
`

SearchBoxForm.propTypes = {
  onToggleSearch: func.isRequired,
  searchExpanded: bool.isRequired,
  onSearchClicked: func.isRequired
}
